import { createSelector } from 'reselect';

export const selectForms = state => state.forms;

export const makeSelectPagedFields = formId =>
  createSelector(selectForms, forms => {
    if (forms?.[formId]) {
      const pagingInfo = forms?.[formId]?.pagingInfo;
      const fields = forms?.[formId]?.fields;
      if (fields?.length > 0 && pagingInfo.pageCount > 1) return fields.filter(f => f.groupId == pagingInfo.currentPageId);
      else return fields;
    }
  });

export const makeSelectFormStatus = formId =>
  createSelector(selectForms, forms => forms?.[formId]?.status);
    
export const makeSelectPagingInfo = formId =>
  createSelector(selectForms, forms => forms?.[formId]?.pagingInfo);

export const makeSelectFormSettings = formId =>
  createSelector(selectForms, forms => forms?.[formId]?.settings)
    
export const makeSelectFormFieldErrors = formId =>
  createSelector(selectForms, forms => forms?.[formId]?.fieldErrors);

export const makeSelectFormEntries = formId =>
  createSelector(selectForms, forms => forms?.[formId]?.entries);

export const makeSelectFormPostData = formId =>
  createSelector(selectForms, forms => forms?.[formId]?.data);

export const makeSelectIsLoading = formId =>
  createSelector(selectForms, forms => forms?.[formId]?.status.isLoading);

  export const makeSelectIsSubmitting = formId =>
  createSelector(selectForms, forms => forms?.[formId]?.status.isSubmitting);

export const makeSelectHasSuccess = formId =>
  createSelector(selectForms, forms => forms?.[formId]?.status.hasSuccess);

export const makeSelectHasError = formId =>
  createSelector(selectForms, forms => forms?.[formId]?.status.hasError);

export const makeSelectFormFields = formId =>
  createSelector(selectForms, forms => forms?.[formId]?.fields);

export const makeSelectDefaultLang = formId =>
  createSelector(selectForms, forms => forms?.[formId]?.defaultLanguage);

export const makeSelectFormSuccessMessage = formId =>
  createSelector(selectForms, forms => forms?.[formId]?.status.messages.success);

export const makeSelectFormValidationSent = formId =>
  createSelector(selectForms, forms => forms?.[formId]?.status.validation.sent);

export const makeSelectFormGroup = formId =>
  createSelector(selectForms, forms => forms?.[formId]?.groups);


export const selectors = {
  selectForms,
  makeSelectPagedFields,
  makeSelectFormStatus,
  makeSelectPagingInfo,
  makeSelectFormSettings,
  makeSelectFormFieldErrors,
  makeSelectFormEntries,
  makeSelectFormPostData,
  makeSelectIsLoading,
  makeSelectIsSubmitting,
  makeSelectHasSuccess,
  makeSelectFormFields,
  makeSelectDefaultLang,
  makeSelectFormSuccessMessage,
  makeSelectFormValidationSent,
  makeSelectFormGroup,
  makeSelectHasError
}
